import cn from "classnames";
import React, { ReactNode, useState } from "react";
import styles from "./Input.module.scss";

export type TextareaProps = {
  label?: string;
  placeholder?: string;
  name: string;
  type?: string;
  initialValue?: string;
  maxLength?: number;
  error?: boolean | ReactNode;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent) => void;
  className?: string;
  onBlur?: (event: React.FocusEvent) => void;
};

export const Textarea = ({
  label,
  placeholder,
  name,
  initialValue,
  maxLength = 500,
  error = false,
  disabled = false,
  onChange,
  className = "",
  onBlur,
}: TextareaProps) => {
  const [charNum, setCharNum] = useState(initialValue?.length || 0);

  const onValueChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputLength = event.target.value.length;
    onChange && onChange(event);
    setCharNum(inputLength);
  };

  return (
    <>
      <label
        className={cn(styles.input, styles.textarea, className, {
          [styles.textareaError]: error,
        })}
      >
        {label && <span className={styles.inputLabel}>{label}</span>}
        <div className={styles.textareaWrap}>
          <textarea
            placeholder={placeholder}
            name={name}
            maxLength={maxLength}
            onChange={onValueChange}
            disabled={disabled}
            onBlur={onBlur}
          />
          <span className={styles.textareaBorder} />
        </div>

        <div className={styles.characters}>
          Characters left: <span className={styles.charNum}>{maxLength - charNum}</span> / {maxLength}
        </div>
      </label>
      {error && typeof error !== "boolean" && <span className={styles.inputErrorMsg}>{error}</span>}
    </>
  );
};
